import { SnLonLatLike } from '@lib/geo/helpers';
import { IMapMarkerOptions } from '@lib/geo/map';

import { GoogleMapStyle } from '../enums';

export interface IGoogleMapOptions {
  center?: SnLonLatLike;
  style?: GoogleMapStyle;
  zoom?: number;
  maxZoom?: number;
  minZoom?: number;
  draggable?: boolean;
  scrollwheel?: boolean;
  keyboardShortcuts?: boolean;
  tilt?: number;
  heading?: number;
  backgroundColor?: string;
  marker?: IMapMarkerOptions;
  mapId?: string;
  isFractionalZoomEnabled?: boolean;
  noClear?: boolean;
  gestureHandling?: string;
  rotateControl?: boolean;
}
